/* istanbul ignore file */
export enum FilterActionTypes {
  CHANGE_FILTER = 'filter-change',
  CLEAR_ALL = 'filter-clear-all',
  CLEAR_ONE = 'filter-clear-one',
  INIT = 'filters-init',
}
